module.exports = __webpack_public_path__ + "img/terroir-inspect-small.fc2288e5.jpg";